<template>
	<div class="p_box" id="box">
		<el-breadcrumb separator="/" id="head">
			<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>{{ id == 1 ? '学校题库' : '我的题库' }}</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="mine_header p_m_t_30" id="heads">
			<div class=" header_left p_flex p_f_a p_f_c">
				<div class="p_flex p_f_a small_hand" v-for="(item, index) in headerList" :key="index" @click="goHeader(index, item.id)">
					<div :class="[headerIndex == index ? 'tababr_com' : '']">{{ item.name }}</div>
					<div v-show="headerIndex == index" class="header_heng"></div>
				</div>
			<!-- 	<div class="p_flex p_f_a small_hand" v-if="id != 1"  @click="goHeader(2, 3)">
					<div :class="[headerIndex == 2 ? 'tababr_com' : '']">答题卡</div>
					<div v-show="headerIndex == 2" class="header_heng"></div>
				</div> -->
				<div v-show="id == 1 ? false : true">
					<el-button @click="goSingle(2)" v-show="headerIndex == 0 ? true : false" class="heaer_btn" type="warning">新建习题</el-button>
					<el-button @click="goExercise" v-show="headerIndex == 1 ? true : false" class="heaer_btn" type="warning">新建习题册</el-button>
					<div style="width: 20px;" class="heaer_btn" v-show="headerIndex == 2 ? true : false" ></div>
				</div>
				<div v-show="id == 1 ? true : false"><div class="divs"></div></div>

			</div>
		</div>
		<div id="" class="overflow " :style="{ height: height + 'px' }" style="background-color: #FFFFFF;">
			<div class="mine_comm p_m_t_20" id="headb"><mine-header @Headerindex="Headerindex" @headerindexs="headerindexs" @headerindexss="headerindexss" :o="o"></mine-header></div>
			 <div class="mine_list p_m_t_20  " >
				<mine-exercises v-show="headerIndex == 0 ? true : false" :age="age" :ages="ages" :agess="agess"></mine-exercises>
				<mine-book @goIssue="goIssue" v-show="headerIndex == 1 ? true :false" :ages="ages" :agess="agess"></mine-book>
				<mine-sheet @goIssue="goIssue" v-show="headerIndex==2?true:false" :ages="ages" :agess="agess"></mine-sheet>
			</div>
		</div>
		<mine-issue :show="show" :op="op" @closes="closes" @goButton="goButton"></mine-issue>
	</div>
</template>

<script>
import MineHeader from '../commponents/mineHeader.vue';
import MineExercises from '../commponents/mineExercises.vue';
import MineBook from '../commponents/mineBook.vue';
import MineIssue from '../commponents/mineIssue.vue';
import MineSheet from '../commponents/mineSheet.vue'
export default {
	name: 'Mine',
	components: {
		MineHeader,
		MineExercises,
		MineBook,
		MineIssue,
		MineSheet
	},

	data() {
		return {
			headerIndex: 0,
			headerList: [
				{
					id: 1,
					name: '习题'
				},
				{
					id: 2,
					name: '习题册'
				},
				{
					id: 3,
					name: '答题卡'
				},

			],
			show: false,
			age: 0,
			ages: 0,
			agess: 0,
			o: '',
			id: '',
			op: {},
			height: 0
		};
	},
	created() {
		// console.log(this.$route.query.id)
		this.id = this.$route.query.id;
		if(this.$route.query.id){
			this.headerIndex = this.$route.query.id - 1;
		}
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Mine') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	mounted() {
		this.indexInfo();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			// var heads = document.getElementById('heads').offsetHeight;
			var height = box - head - 30 - 20 - 20 - 20;
			var heights = localStorage.getItem('height');
			localStorage.setItem('height', height);
			this.height = height;
			console.log(height)
			// setTimeout(res=>{
			// 	var headb = document.getElementById('headb').offsetHeight;
			// 	if (this.headerIndex == 0) {
			// 		var height = box - head  - heads  - 30 - 20 - 20 - headb;
			// 	} else if( this.headerIndex == 1 )  {
			// 		var height = box - head - heads - headb  - 30 - 20 - 20;
			// 	}else{
			// 		var height = box - head - heads - headb - 30 - 20 - 20 ;
			// 	}
			// 	var heights = localStorage.getItem('height');
			// 	localStorage.setItem('height', height);
			// 	this.height = height;
			// },1000)

		},
		// 头部切换
		goHeader(i, o) {
			this.headerIndex = i;
			// console.log(o)
			this.o = o;
			this.indexInfo();
		},
		// 选择类型
		Headerindex(i) {
			this.age = i;
		},
		headerindexs(i) {
			// console.log(i)
			this.ages = i;
		},
		headerindexss(i) {
			// console.log(i)
			this.agess = i;
		},
		// 新建习题
		goSingle(i) {
			this.$router.push({
				path: 'Single',
				query: {
					id: i
				}
			});
		},
		// 新建习题册
		goExercise() {
			// this.$router.push({
			// 	path: `/Exercise`
			// });
			this.$router.push({
				path: `/NewExercises`
			});

		},
		// 下发作业
		goIssue(val, o) {
			this.show = val;
			// console.log(o)
			this.op = o;
		},
		// 关闭按钮
		closes(val) {
			this.show = val;
		},
		// 下发作业确认按钮
		goButton(val) {
			this.show = val;
		}
	}
};
</script>
<style lang="scss" scoped>
.p_box {
	position: relative;
}
.divs {
	margin-left: 530px;
}
.mine_header {
	background-color: #fafafa;
	height: 60px;
}

.header_left > div {
	height: 100%;
	position: relative;
}

.header_left > div:nth-child(2) {
	margin-left: 50px;
}

.header_left > div:nth-child(3) {
	margin-left: 50px;
}

.header_left {
	height: 100%;
}

.header_heng {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 80%;
	height: 2px;
	background-color: #000000;
}
.tababr_com {
	font-weight: bold;
}
.heaer_btn {
	margin-top: 10px;
	margin-left: 440px !important;
}
.mine_comm {
	padding: 0 230px;
	background-color: #ffffff;
}
.mine_list {
	// padding: 0 220px;
	background-color: #ffffff;
	padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/mine/index.vue